import { NgModule, ModuleWithProviders, NgModuleFactoryLoader, SystemJsNgModuleLoader } from '@angular/core';
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { DatePipe } from '@angular/common';

// import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';
// import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
// import { ButtonsModule } from 'ngx-bootstrap/buttons';
// import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
// import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
// import { PaginationModule } from 'ngx-bootstrap/pagination';

// import { BarRatingModule } from "ngx-bar-rating";
// import { ColorPickerModule } from 'ngx-color-picker';
// import { TagInputModule } from 'ngx-chips';
// import { TimeagoModule } from 'ngx-timeago';
// import { ToastrModule } from 'ngx-toastr';
// import { AngularFontAwesomeModule } from 'angular-font-awesome';
// // import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
// import { NgxSpinnerModule } from 'ngx-spinner';

// import { ChartsModule } from 'ng2-charts';
// import { NgxBootstrapSliderModule } from 'ngx-bootstrap-slider';
// import { ProgressbarModule } from 'ngx-bootstrap';
// import { ImportMaterialModule, ToolsModule, UIService } from 'ess-plugin-ui';

import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { InplaceModule } from 'primeng/inplace';
import { RatingModule } from 'primeng/rating';
import { SplitButtonModule } from 'primeng/splitbutton';
import { InputTextModule } from 'primeng/inputtext';
import { InputMaskModule } from 'primeng/inputmask';
import { MultiSelectModule } from 'primeng/multiselect';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    TableModule,
    ButtonModule,
    CheckboxModule,
    DropdownModule,
    CalendarModule,
    InplaceModule,
    RatingModule,
    SplitButtonModule,
    InputTextModule,
    // InputNumberModule,
    InputMaskModule,
    MultiSelectModule,

  ],
  declarations: [
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    TableModule,
    ButtonModule,
    CheckboxModule,
    DropdownModule,
    CalendarModule,
    InplaceModule,
    RatingModule,
    SplitButtonModule,
    InputTextModule,
    // InputNumberModule,
    InputMaskModule,
    MultiSelectModule,
    
  ],
  providers: []
})
export class ImportPrimeModule {

}
